import { render, staticRenderFns } from "./adMarketing.vue?vue&type=template&id=520f5b6a&scoped=true"
import script from "./adMarketing.vue?vue&type=script&lang=js"
export * from "./adMarketing.vue?vue&type=script&lang=js"
import style0 from "./adMarketing.vue?vue&type=style&index=0&id=520f5b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f5b6a",
  null
  
)

export default component.exports